/**
 * Human-readable names for the internal keys the analytics tables store.
 *
 * Keys on the left are exactly what the backend emits: the screen names in
 * backend/scripts/backfill_first_action.py TRACKED_SCREENS, the section names
 * in app/services/profile_completeness.py, and the athlete_activity_events
 * event types. An unknown key falls back to `humanize()` rather than showing
 * the raw database name, so a newly added action never leaks snake_case.
 */
export const ACTION_LABELS = {
  profile_updated: 'Updated profile',
  photo_uploaded: 'Uploaded a photo',
  video_uploaded: 'Uploaded a video',
  video_linked: 'Linked a video',
  document_uploaded: 'Uploaded a document',
  accolade_added: 'Added an accolade',
  card_builder_opened: 'Opened the card builder',
  card_created: 'Created a trading card',
  card_edited: 'Edited a trading card',
  recruiting_follow_added: 'Added a recruiting follow',
  recruiting_offer_added: 'Added a recruiting offer',
  recruiting_visit_added: 'Added a recruiting visit',
  guardian_invited: 'Invited a guardian',
  camp_registered: 'Registered for a camp',
};

export const SECTION_LABELS = {
  position_sport: 'Position & sport',
  measurables: 'Measurables',
  academics: 'Academics',
  photo: 'Photo',
  video: 'Video',
  competition_record: 'Competition record',
  transcript: 'Transcript',
  accolades: 'Accolades',
};

// athlete_activity_events.event_type
export const CHANGE_LABELS = {
  profile_updated: 'Changed a profile field',
  photo_added: 'Added a photo',
  offer_added: 'Added an offer',
  athlete_joined: 'Joined',
};

export function humanize(key) {
  if (!key) return '';
  const spaced = String(key).replace(/_/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function labelFor(map, key) {
  return map[key] ?? humanize(key);
}
